import { type IssueData, z } from "zod";

/**
 * RFC 5321 - Simple Mail Transfer Protocol 日本語訳
 * @see https://tex2e.github.io/rfc-translater/html/rfc5321.html
 *
 * RFC 5322 - Internet Message Format 日本語訳
 * @see https://tex2e.github.io/rfc-translater/html/rfc5322.html
 *
 * 上記を考慮して以下のサイトを参考にカスタマイズ
 * @see https://qiita.com/komekami0131/items/7a7834ea63eb0f22d161
 *
 * フォーマット
 * @see ^(([^<>()[\]\.,;:\s@"]+(\.[^<>()[\]\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z0-9]+([a-zA-Z0-9-]+[a-zA-Z0-9]+)*\.)+[a-zA-Z]{2,}))$
 */
const EMAIL_REGEXP =
  // eslint-disable-next-line no-useless-escape
  /^(([^<>()[\]\.,;:\s@"]+(\.[^<>()[\]\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z0-9]+([a-zA-Z0-9-]+[a-zA-Z0-9]+)*\.)+[a-zA-Z]{2,}))$/;
const FULL_WIDTH_REGEXP = /[^\u0020-\u007E]/;
const EMAIL_ALL_MAX_LENGTH = 320;

const EmailRegexpError: IssueData = {
  code: z.ZodIssueCode.custom,
  params: { i18n: "custom.email_regexp_error" },
};

const EmailRegexpDoubleByteError: IssueData = {
  code: z.ZodIssueCode.custom,
  params: { i18n: "custom.email_regexp_double_byte" },
};

const EmailAllLengthMaxError: IssueData = {
  code: z.ZodIssueCode.custom,
  params: {
    i18n: {
      key: "custom.email_all_length_max",
      values: { value: EMAIL_ALL_MAX_LENGTH },
    },
  },
};

/**
 * メールアドレスのschema定義
 *
 * Optional/Requiredは設定しないので、利用側で設定してください
 */
export const emailSchema = z.string().superRefine((val, ctx) => {
  // 任意入力のケースもあるので、undefined, null, "" はチェックしない
  // 必須の場合はここではなく別でチェックすること
  if (val === undefined || val === null || val === "") return;
  if (!EMAIL_REGEXP.test(val)) {
    ctx.addIssue(EmailRegexpError);
  }
  if (FULL_WIDTH_REGEXP.test(val)) {
    ctx.addIssue(EmailRegexpDoubleByteError);
  }
  if (val.length > EMAIL_ALL_MAX_LENGTH) {
    ctx.addIssue(EmailAllLengthMaxError);
  }
});
